import React from 'react';
import { SectionCard } from '../../components/sections/SectionCard';
import { PanelTable } from '../../components/display/PanelTable';
import { AppStatusBadge } from '@shared/components/ui/status-badge/AppStatusBadge';
import type { PanelTableColumn } from '../../components/display/PanelTable/types';
import { SUBSCRIPTION_DATA, type SubscriptionData } from '@shared/data';

interface SubscriptionsSectionProps {
  isDetailView?: boolean;
  className?: string;
}

const renderStatus = (_: unknown, item: SubscriptionData) => (
  <div className="whitespace-nowrap">
    <AppStatusBadge 
      entityType="subscription" 
      status={item.status}
      size="sm"
    />
  </div>
);

const renderNextBilling = (_: unknown, item: SubscriptionData) => (
  <div className="text-xs">
    <span className="font-medium">{item.nextBilling}</span>
    <span className="text-muted-foreground ml-2">{item.amount}</span>
  </div>
);

export const SubscriptionsSection = React.memo<SubscriptionsSectionProps>(({ isDetailView = false, className }) => {
  const columns: PanelTableColumn<SubscriptionData>[] = [
    {
      key: 'product',
      label: 'PRODUCT',
      headerClassName: 'w-[120px]',
      cellClassName: 'font-medium'
    },
    {
      key: 'description',
      label: 'DESCRIPTION',
      headerClassName: 'w-[180px]',
      cellClassName: 'text-muted-foreground truncate max-w-[180px]'
    },
    {
      key: 'amount',
      label: 'AMOUNT',
      headerClassName: 'w-[90px]',
      cellClassName: 'font-medium'
    },
    {
      key: 'status',
      label: 'STATUS',
      headerClassName: 'w-[90px]',
      render: renderStatus
    },
    {
      key: 'items',
      label: 'ITEMS',
      headerClassName: 'w-[70px]',
      cellClassName: 'text-center'
    },
    {
      key: 'frequency',
      label: 'FREQUENCY',
      headerClassName: 'w-[100px]',
      cellClassName: 'text-muted-foreground'
    },
    {
      key: 'nextBilling',
      label: 'NEXT BILLING',
      headerClassName: 'w-[140px]',
      cellClassName: 'whitespace-nowrap',
      render: renderNextBilling
    }
  ];

  const rowActions = (item: SubscriptionData) => [
    {
      key: 'update-subscription',
      label: 'Update subscription',
      onClick: () => console.log('Update subscription', item)
    },
    {
      key: 'cancel-subscription',
      label: 'Cancel subscription',
      onClick: () => console.log('Cancel subscription', item)
    },
    {
      key: 'pause-payment',
      label: 'Pause payment collection',
      onClick: () => console.log('Pause payment collection', item)
    },
    {
      key: 'share-link',
      label: 'Share payment update link',
      onClick: () => console.log('Share payment update link', item)
    },
    {
      key: 'view-subscription',
      label: 'View subscription',
      onClick: () => console.log('View subscription', item)
    },
    {
      key: 'view-invoice',
      label: 'View upcoming invoice',
      onClick: () => console.log('View upcoming invoice', item)
    }
  ];

  return (
    <SectionCard title="Subscriptions" layout="down" className={className}>
      <PanelTable
        data={SUBSCRIPTION_DATA}
        columns={columns}
        variant={isDetailView ? 'full' : 'panel'}
        emptyMessage="No subscriptions found"
        pageSize={5}
        rowActions={rowActions}
      />
    </SectionCard>
  );
});

SubscriptionsSection.displayName = 'SubscriptionsSection';